/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Document Service API
 * Document management and presigned URL generation for CTE platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateUploadBatchRequest,
  CreateUploadBatchResponse,
  CreateUploadURLRequest,
  CreateUploadURLResponse,
  DocumentDetailDTO,
  ErrorResponse,
  GetBulkDownloadURLsRequest,
  GetBulkDownloadURLsResponse,
  GetDocumentResponse,
  GetDownloadURLParams,
  GetDownloadURLResponse,
  GetPublicUploadURLRequest,
  GetPublicUploadURLResponse,
  GetUploadBatchResponse,
  LinkDocumentRequest,
  LinkDocumentResponse,
  LinkQueueDocumentDTO,
  ListDocumentLibraryParams,
  ListDocumentLibraryResponse,
  ListDocumentTypesParams,
  ListDocumentTypesResponse,
  ListLinkReviewQueueParams,
  ListLinkReviewQueueResponse,
  ListUploadBatchesParams,
  ListUploadBatchesResponse,
  RecordUploadBatchResultsRequest,
  RecordUploadBatchResultsResponse,
  SetLinkReviewRequest,
  UnlinkDocumentParams,
  UpdateDocumentRequest,
  UploadBatchDTO
} from './model';

import { customFetch } from './custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCreateUploadURLUrl = () => {




  return `/api/documents/upload-url`
}

/**
 * Creates a document owned by document-svc for a purpose-driven upload
 * flow (sow_document, inspection_sheet, inspection_photo,
 * equipment_bulk_upload, etc.) and returns a presigned S3 URL the
 * caller can PUT to. The document is persisted with a site link and an
 * initial purpose-keyed link row keyed by `owner_id`, so downstream
 * services can react to the eventual `document.uploaded` event.
 *
 * Authorization: the caller's `X-Site-Claims` must include the
 * `site_id` supplied in the request body.
 * @summary Create a document and return a presigned upload URL
 */
export const createUploadURL = async (createUploadURLRequest: CreateUploadURLRequest, options?: RequestInit): Promise<CreateUploadURLResponse> => {

  return customFetch<CreateUploadURLResponse>(getCreateUploadURLUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createUploadURLRequest)
  }
);}





export const getCreateUploadURLMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUploadURL>>, TError,{data: CreateUploadURLRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUploadURL>>, TError,{data: CreateUploadURLRequest}, TContext> => {

const mutationKey = ['createUploadURL'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUploadURL>>, {data: CreateUploadURLRequest}> = (props) => {
          const {data} = props ?? {};

          return  createUploadURL(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUploadURLMutationResult = NonNullable<Awaited<ReturnType<typeof createUploadURL>>>
    export type CreateUploadURLMutationBody = CreateUploadURLRequest
    export type CreateUploadURLMutationError = ErrorResponse

    /**
 * @summary Create a document and return a presigned upload URL
 */
export const useCreateUploadURL = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUploadURL>>, TError,{data: CreateUploadURLRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUploadURL>>,
        TError,
        {data: CreateUploadURLRequest},
        TContext
      > => {
      return useMutation(getCreateUploadURLMutationOptions(options), queryClient);
    }

export const getGetPublicUploadURLUrl = () => {




  return `/api/documents/public/upload-url`
}

/**
 * Uploads to the public bucket (e.g. marketing-site assets).
 *
 * Unauthenticated by design: no site-scoped ownership applies to
 * objects in the public bucket, so no `X-Site-Claims` check is
 * performed. All other document-svc upload endpoints are site-claim
 * gated.
 * @summary Generate a presigned upload URL for a public document
 */
export const getPublicUploadURL = async (getPublicUploadURLRequest: GetPublicUploadURLRequest, options?: RequestInit): Promise<GetPublicUploadURLResponse> => {

  return customFetch<GetPublicUploadURLResponse>(getGetPublicUploadURLUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(getPublicUploadURLRequest)
  }
);}





export const getGetPublicUploadURLMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPublicUploadURL>>, TError,{data: GetPublicUploadURLRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof getPublicUploadURL>>, TError,{data: GetPublicUploadURLRequest}, TContext> => {

const mutationKey = ['getPublicUploadURL'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPublicUploadURL>>, {data: GetPublicUploadURLRequest}> = (props) => {
          const {data} = props ?? {};

          return  getPublicUploadURL(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPublicUploadURLMutationResult = NonNullable<Awaited<ReturnType<typeof getPublicUploadURL>>>
    export type GetPublicUploadURLMutationBody = GetPublicUploadURLRequest
    export type GetPublicUploadURLMutationError = ErrorResponse

    /**
 * @summary Generate a presigned upload URL for a public document
 */
export const useGetPublicUploadURL = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPublicUploadURL>>, TError,{data: GetPublicUploadURLRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPublicUploadURL>>,
        TError,
        {data: GetPublicUploadURLRequest},
        TContext
      > => {
      return useMutation(getGetPublicUploadURLMutationOptions(options), queryClient);
    }

export const getMarkDocumentUploadedUrl = (id: string,) => {




  return `/api/documents/${id}/uploaded`
}

/**
 * Called after a successful PUT to the presigned upload URL. Publishes
 * a document.uploaded event.
 *
 * Authorization: the caller's `X-Site-Claims` must include the
 * document's site. Callers lacking the claim receive the same `404`
 * as an unknown ID to prevent cross-site enumeration.
 * @summary Confirm that a document has been uploaded to S3
 */
export const markDocumentUploaded = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getMarkDocumentUploadedUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkDocumentUploadedMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markDocumentUploaded>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markDocumentUploaded>>, TError,{id: string}, TContext> => {

const mutationKey = ['markDocumentUploaded'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markDocumentUploaded>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  markDocumentUploaded(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkDocumentUploadedMutationResult = NonNullable<Awaited<ReturnType<typeof markDocumentUploaded>>>

    export type MarkDocumentUploadedMutationError = ErrorResponse

    /**
 * @summary Confirm that a document has been uploaded to S3
 */
export const useMarkDocumentUploaded = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markDocumentUploaded>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markDocumentUploaded>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getMarkDocumentUploadedMutationOptions(options), queryClient);
    }

export const getGetDownloadURLUrl = (id: string,
    params?: GetDownloadURLParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/documents/${id}/download-url?${stringifiedParams}` : `/api/documents/${id}/download-url`
}

/**
 * Authorization: the caller's `X-Site-Claims` must include the
 * document's site. Callers lacking the claim receive the same `404`
 * as an unknown ID to prevent cross-site enumeration.
 *
 * The `audience` query parameter selects which S3 host the URL is
 * signed against — `public` (default) for browsers, `internal` for
 * service-to-service consumers running inside the cluster.
 * @summary Generate a presigned download URL for a document
 */
export const getDownloadURL = async (id: string,
    params?: GetDownloadURLParams, options?: RequestInit): Promise<GetDownloadURLResponse> => {

  return customFetch<GetDownloadURLResponse>(getGetDownloadURLUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDownloadURLQueryKey = (id: string,
    params?: GetDownloadURLParams,) => {
    return [
    `/api/documents/${id}/download-url`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDownloadURLQueryOptions = <TData = Awaited<ReturnType<typeof getDownloadURL>>, TError = ErrorResponse>(id: string,
    params?: GetDownloadURLParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadURL>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDownloadURLQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDownloadURL>>> = ({ signal }) => getDownloadURL(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDownloadURL>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDownloadURLQueryResult = NonNullable<Awaited<ReturnType<typeof getDownloadURL>>>
export type GetDownloadURLQueryError = ErrorResponse


export function useGetDownloadURL<TData = Awaited<ReturnType<typeof getDownloadURL>>, TError = ErrorResponse>(
 id: string,
    params: undefined |  GetDownloadURLParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadURL>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadURL>>,
          TError,
          Awaited<ReturnType<typeof getDownloadURL>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadURL<TData = Awaited<ReturnType<typeof getDownloadURL>>, TError = ErrorResponse>(
 id: string,
    params?: GetDownloadURLParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadURL>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadURL>>,
          TError,
          Awaited<ReturnType<typeof getDownloadURL>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDownloadURL<TData = Awaited<ReturnType<typeof getDownloadURL>>, TError = ErrorResponse>(
 id: string,
    params?: GetDownloadURLParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadURL>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Generate a presigned download URL for a document
 */

export function useGetDownloadURL<TData = Awaited<ReturnType<typeof getDownloadURL>>, TError = ErrorResponse>(
 id: string,
    params?: GetDownloadURLParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadURL>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDownloadURLQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetBulkDownloadURLsUrl = () => {




  return `/api/documents/bulk-download-urls`
}

/**
 * Takes a list of storage keys and returns a presigned download URL plus
 * metadata for each one the caller is authorized to access. Storage keys
 * with no matching document, or whose owning site is not in the caller's
 * `X-Site-Claims`, are returned in `not_found` / `forbidden` so callers
 * can render a partial bundle and surface what was skipped.
 *
 * Used to power client-side bulk downloads (e.g. zipping a SOW's
 * documents in the browser) without round-tripping each document
 * through `/documents/{id}/download-url`.
 * @summary Resolve a batch of storage keys to presigned download URLs
 */
export const getBulkDownloadURLs = async (getBulkDownloadURLsRequest: GetBulkDownloadURLsRequest, options?: RequestInit): Promise<GetBulkDownloadURLsResponse> => {

  return customFetch<GetBulkDownloadURLsResponse>(getGetBulkDownloadURLsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(getBulkDownloadURLsRequest)
  }
);}





export const getGetBulkDownloadURLsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getBulkDownloadURLs>>, TError,{data: GetBulkDownloadURLsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof getBulkDownloadURLs>>, TError,{data: GetBulkDownloadURLsRequest}, TContext> => {

const mutationKey = ['getBulkDownloadURLs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getBulkDownloadURLs>>, {data: GetBulkDownloadURLsRequest}> = (props) => {
          const {data} = props ?? {};

          return  getBulkDownloadURLs(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetBulkDownloadURLsMutationResult = NonNullable<Awaited<ReturnType<typeof getBulkDownloadURLs>>>
    export type GetBulkDownloadURLsMutationBody = GetBulkDownloadURLsRequest
    export type GetBulkDownloadURLsMutationError = ErrorResponse

    /**
 * @summary Resolve a batch of storage keys to presigned download URLs
 */
export const useGetBulkDownloadURLs = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getBulkDownloadURLs>>, TError,{data: GetBulkDownloadURLsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getBulkDownloadURLs>>,
        TError,
        {data: GetBulkDownloadURLsRequest},
        TContext
      > => {
      return useMutation(getGetBulkDownloadURLsMutationOptions(options), queryClient);
    }

export const getGetDocumentUrl = (id: string,) => {




  return `/api/documents/${id}`
}

/**
 * Returns the document's full metadata — filename, content type, size,
 * site, storage key, decoded metadata map, and the upload-time
 * (purpose, owner_id) link if one was created during the upload flow.
 *
 * Intended for service-to-service lookups: a consumer that needs to
 * materialise a document reference (e.g. defect-svc cross-linking an
 * existing inspection photo) calls this to retrieve the bits it can't
 * get from the public API surface (storage_key, site_id).
 *
 * Authorization: the caller's `X-Site-Claims` must include the
 * document's site. Callers lacking the claim receive `404` (existence
 * is conflated with authorization to avoid cross-site enumeration).
 * @summary Get document metadata
 */
export const getDocument = async (id: string, options?: RequestInit): Promise<GetDocumentResponse> => {

  return customFetch<GetDocumentResponse>(getGetDocumentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDocumentQueryKey = (id: string,) => {
    return [
    `/api/documents/${id}`
    ] as const;
    }


export const getGetDocumentQueryOptions = <TData = Awaited<ReturnType<typeof getDocument>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocument>>> = ({ signal }) => getDocument(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getDocument>>>
export type GetDocumentQueryError = ErrorResponse


export function useGetDocument<TData = Awaited<ReturnType<typeof getDocument>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocument>>,
          TError,
          Awaited<ReturnType<typeof getDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocument<TData = Awaited<ReturnType<typeof getDocument>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocument>>,
          TError,
          Awaited<ReturnType<typeof getDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocument<TData = Awaited<ReturnType<typeof getDocument>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get document metadata
 */

export function useGetDocument<TData = Awaited<ReturnType<typeof getDocument>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateDocumentUrl = (id: string,) => {




  return `/api/documents/${id}`
}

/**
 * Corrects a document's display name, its type, or both. At least one
 * field must be present.
 *
 * **The filename is a display name, and the stored object is not moved.**
 * `storage_key` embeds the name the file arrived under, is unique, is
 * copied into equipment-svc's projection, and is matched as a prefix by
 * the scope-of-work and inspection cascade deletes. Renaming therefore
 * lets the display name and the object key diverge on purpose. Downloads
 * are unaffected — `getDownloadURL` already returns the display filename
 * alongside a URL presigned against the untouched key.
 *
 * Only typed site documents can be edited. Generated artefacts — a
 * scope-of-work title page, a HAC inspection sheet — carry a purpose but
 * no type, and are re-registered under their original filename every time
 * they are regenerated, so a rename would silently come undone. Those
 * return `409`.
 *
 * There is no way to clear the type. A document with no type falls out of
 * the library, the link-review queue and the per-type counts at once, and
 * no screen could bring it back.
 *
 * Publishes `document.updated` through the transactional outbox, so the
 * row and the event commit together. Consumers refresh every row they
 * hold for the document — the event carries no purpose and no owner,
 * because a rename is a fact about the document rather than any one of
 * its links.
 *
 * Authorization: the caller's `X-Site-Claims` must include the document's
 * site, and the caller must be at least an inspector.
 * @summary Rename or re-classify a site document
 */
export const updateDocument = async (id: string,
    updateDocumentRequest: UpdateDocumentRequest, options?: RequestInit): Promise<DocumentDetailDTO> => {

  return customFetch<DocumentDetailDTO>(getUpdateDocumentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateDocumentRequest)
  }
);}





export const getUpdateDocumentMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocument>>, TError,{id: string;data: UpdateDocumentRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDocument>>, TError,{id: string;data: UpdateDocumentRequest}, TContext> => {

const mutationKey = ['updateDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDocument>>, {id: string;data: UpdateDocumentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDocument(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof updateDocument>>>
    export type UpdateDocumentMutationBody = UpdateDocumentRequest
    export type UpdateDocumentMutationError = ErrorResponse

    /**
 * @summary Rename or re-classify a site document
 */
export const useUpdateDocument = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocument>>, TError,{id: string;data: UpdateDocumentRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDocument>>,
        TError,
        {id: string;data: UpdateDocumentRequest},
        TContext
      > => {
      return useMutation(getUpdateDocumentMutationOptions(options), queryClient);
    }

export const getDeleteDocumentUrl = (id: string,) => {




  return `/api/documents/${id}`
}

/**
 * Publishes a `document.deleted` event before removing the S3 object
 * and soft-deleting the database row so consumers can drop their
 * local references first. If the event fails to publish, the
 * deletion is aborted and local references remain valid.
 *
 * Authorization: the caller's `X-Site-Claims` must include the
 * document's site. Callers lacking the claim receive the same `404`
 * as an unknown ID to prevent cross-site enumeration.
 * @summary Delete a document and its S3 object
 */
export const deleteDocument = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteDocumentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDocumentMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocument>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteDocument(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocument>>>

    export type DeleteDocumentMutationError = ErrorResponse

    /**
 * @summary Delete a document and its S3 object
 */
export const useDeleteDocument = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDocument>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteDocumentMutationOptions(options), queryClient);
    }

export const getGetDocumentDetailUrl = (id: string,) => {




  return `/api/documents/${id}/detail`
}

/**
 * What the file is, who put it there and when, and how many pieces of
 * equipment it covers.
 *
 * Separate from `getDocument` rather than an extension of it. That
 * operation is service-to-service: it returns `storage_key`, because a
 * caller minting a presigned URL needs it, and it answers `404` in place
 * of `403` so one service cannot enumerate another's sites. This shape is
 * rendered in a browser, so it carries no storage key and gives an honest
 * `403` — someone who followed a link to a document they can't see should
 * be told that, not told it doesn't exist.
 *
 * `uploaded_by_name` is resolved from the upload batch that brought the
 * document in. It is absent for anything uploaded outside a batch:
 * `documents.uploaded_by` holds an actor id rather than a name, so there
 * is no name to show.
 *
 * `equipment_count` counts link rows, every site's together. Never render
 * it to a person — use equipment-svc's `listEquipmentForDocument` total,
 * or `countEquipmentForDocuments` for a list. Links here carry an opaque
 * owner and no site, and a shared IECEx certificate is one object serving
 * several sites, so this number reports other sites' tags as well as this
 * one's. It also overstates within a site: a link outlives the equipment
 * it points at.
 *
 * Only typed site documents have a page. Generated artefacts and files
 * still mid-upload return `404`, matching the library that would not list
 * them either.
 *
 * Authorization: the caller's `X-Site-Claims` must include the document's
 * site. No role floor — a viewer who can open a document from an
 * equipment record can equally open its page.
 * @summary One document, as its own page reads it
 */
export const getDocumentDetail = async (id: string, options?: RequestInit): Promise<DocumentDetailDTO> => {

  return customFetch<DocumentDetailDTO>(getGetDocumentDetailUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDocumentDetailQueryKey = (id: string,) => {
    return [
    `/api/documents/${id}/detail`
    ] as const;
    }


export const getGetDocumentDetailQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentDetail>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentDetailQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentDetail>>> = ({ signal }) => getDocumentDetail(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentDetail>>>
export type GetDocumentDetailQueryError = ErrorResponse


export function useGetDocumentDetail<TData = Awaited<ReturnType<typeof getDocumentDetail>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentDetail>>,
          TError,
          Awaited<ReturnType<typeof getDocumentDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentDetail<TData = Awaited<ReturnType<typeof getDocumentDetail>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentDetail>>,
          TError,
          Awaited<ReturnType<typeof getDocumentDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentDetail<TData = Awaited<ReturnType<typeof getDocumentDetail>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One document, as its own page reads it
 */

export function useGetDocumentDetail<TData = Awaited<ReturnType<typeof getDocumentDetail>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentDetailQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListDocumentTypesUrl = (params: ListDocumentTypesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/documents/types?${stringifiedParams}` : `/api/documents/types`
}

/**
 * Returns every document type in presentation order, each with the number
 * of documents of that type already held for the site. Types the site has
 * nothing filed under are returned with a count of 0 — the catalogue is
 * fixed, so the list is the same fourteen entries on every site.
 *
 * Only site documents carry a type; inspection photos, defect photos and
 * other purpose-driven uploads are not counted.
 *
 * Authorization: the caller's `X-Site-Claims` must include `siteId`.
 * @summary List the document type catalogue with per-site counts
 */
export const listDocumentTypes = async (params: ListDocumentTypesParams, options?: RequestInit): Promise<ListDocumentTypesResponse> => {

  return customFetch<ListDocumentTypesResponse>(getListDocumentTypesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDocumentTypesQueryKey = (params?: ListDocumentTypesParams,) => {
    return [
    `/api/documents/types`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDocumentTypesQueryOptions = <TData = Awaited<ReturnType<typeof listDocumentTypes>>, TError = ErrorResponse>(params: ListDocumentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentTypesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocumentTypes>>> = ({ signal }) => listDocumentTypes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocumentTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDocumentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listDocumentTypes>>>
export type ListDocumentTypesQueryError = ErrorResponse


export function useListDocumentTypes<TData = Awaited<ReturnType<typeof listDocumentTypes>>, TError = ErrorResponse>(
 params: ListDocumentTypesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof listDocumentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentTypes<TData = Awaited<ReturnType<typeof listDocumentTypes>>, TError = ErrorResponse>(
 params: ListDocumentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof listDocumentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentTypes<TData = Awaited<ReturnType<typeof listDocumentTypes>>, TError = ErrorResponse>(
 params: ListDocumentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the document type catalogue with per-site counts
 */

export function useListDocumentTypes<TData = Awaited<ReturnType<typeof listDocumentTypes>>, TError = ErrorResponse>(
 params: ListDocumentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDocumentTypesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListUploadBatchesUrl = (params: ListUploadBatchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/documents/batches?${stringifiedParams}` : `/api/documents/batches`
}

/**
 * Returns the site's upload batches, newest first — one entry per bulk
 * upload, with the document type it filed under, how many files it
 * carried, and who ran it.
 *
 * Every status is returned, cancelled and in-progress included: an
 * abandoned upload is exactly what someone returns to this screen to
 * find. `total_files` is what the batch was opened with, so a cancelled
 * batch still reports its original size.
 *
 * Authorization: the caller's `X-Site-Claims` must include `siteId`.
 * @summary List a site's bulk document uploads
 */
export const listUploadBatches = async (params: ListUploadBatchesParams, options?: RequestInit): Promise<ListUploadBatchesResponse> => {

  return customFetch<ListUploadBatchesResponse>(getListUploadBatchesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUploadBatchesQueryKey = (params?: ListUploadBatchesParams,) => {
    return [
    `/api/documents/batches`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUploadBatchesQueryOptions = <TData = Awaited<ReturnType<typeof listUploadBatches>>, TError = ErrorResponse>(params: ListUploadBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUploadBatches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUploadBatchesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUploadBatches>>> = ({ signal }) => listUploadBatches(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUploadBatches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUploadBatchesQueryResult = NonNullable<Awaited<ReturnType<typeof listUploadBatches>>>
export type ListUploadBatchesQueryError = ErrorResponse


export function useListUploadBatches<TData = Awaited<ReturnType<typeof listUploadBatches>>, TError = ErrorResponse>(
 params: ListUploadBatchesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUploadBatches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUploadBatches>>,
          TError,
          Awaited<ReturnType<typeof listUploadBatches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUploadBatches<TData = Awaited<ReturnType<typeof listUploadBatches>>, TError = ErrorResponse>(
 params: ListUploadBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUploadBatches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUploadBatches>>,
          TError,
          Awaited<ReturnType<typeof listUploadBatches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUploadBatches<TData = Awaited<ReturnType<typeof listUploadBatches>>, TError = ErrorResponse>(
 params: ListUploadBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUploadBatches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a site's bulk document uploads
 */

export function useListUploadBatches<TData = Awaited<ReturnType<typeof listUploadBatches>>, TError = ErrorResponse>(
 params: ListUploadBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUploadBatches>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUploadBatchesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateUploadBatchUrl = () => {




  return `/api/documents/batches`
}

/**
 * Records a batch of files to be uploaded under a single document type
 * and returns a presigned PUT URL for each acceptable file. The browser
 * uploads directly to S3 and reports outcomes back via
 * `/documents/batches/{id}/results`.
 *
 * Files over the per-file size limit are rejected here rather than
 * silently dropped: they come back with `status: FAILED`, a
 * `failure_reason`, and no `upload_url`.
 *
 * Authorization: the caller's `X-Site-Claims` must include `site_id`.
 * @summary Open a bulk document upload batch
 */
export const createUploadBatch = async (createUploadBatchRequest: CreateUploadBatchRequest, options?: RequestInit): Promise<CreateUploadBatchResponse> => {

  return customFetch<CreateUploadBatchResponse>(getCreateUploadBatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createUploadBatchRequest)
  }
);}





export const getCreateUploadBatchMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUploadBatch>>, TError,{data: CreateUploadBatchRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUploadBatch>>, TError,{data: CreateUploadBatchRequest}, TContext> => {

const mutationKey = ['createUploadBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUploadBatch>>, {data: CreateUploadBatchRequest}> = (props) => {
          const {data} = props ?? {};

          return  createUploadBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUploadBatchMutationResult = NonNullable<Awaited<ReturnType<typeof createUploadBatch>>>
    export type CreateUploadBatchMutationBody = CreateUploadBatchRequest
    export type CreateUploadBatchMutationError = ErrorResponse

    /**
 * @summary Open a bulk document upload batch
 */
export const useCreateUploadBatch = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUploadBatch>>, TError,{data: CreateUploadBatchRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUploadBatch>>,
        TError,
        {data: CreateUploadBatchRequest},
        TContext
      > => {
      return useMutation(getCreateUploadBatchMutationOptions(options), queryClient);
    }

export const getGetUploadBatchUrl = (id: string,) => {




  return `/api/documents/batches/${id}/status`
}

/**
 * Returns the batch with every file and a per-status tally. This is what
 * lets progress survive a reload — the browser is the uploader, so the
 * batch is the only durable record of what was attempted.
 *
 * Authorization: the caller's `X-Site-Claims` must include the batch's site.
 * @summary Read a bulk upload batch, its files and progress
 */
export const getUploadBatch = async (id: string, options?: RequestInit): Promise<GetUploadBatchResponse> => {

  return customFetch<GetUploadBatchResponse>(getGetUploadBatchUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUploadBatchQueryKey = (id: string,) => {
    return [
    `/api/documents/batches/${id}/status`
    ] as const;
    }


export const getGetUploadBatchQueryOptions = <TData = Awaited<ReturnType<typeof getUploadBatch>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadBatch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUploadBatchQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUploadBatch>>> = ({ signal }) => getUploadBatch(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUploadBatch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUploadBatchQueryResult = NonNullable<Awaited<ReturnType<typeof getUploadBatch>>>
export type GetUploadBatchQueryError = ErrorResponse


export function useGetUploadBatch<TData = Awaited<ReturnType<typeof getUploadBatch>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadBatch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUploadBatch>>,
          TError,
          Awaited<ReturnType<typeof getUploadBatch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUploadBatch<TData = Awaited<ReturnType<typeof getUploadBatch>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadBatch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUploadBatch>>,
          TError,
          Awaited<ReturnType<typeof getUploadBatch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUploadBatch<TData = Awaited<ReturnType<typeof getUploadBatch>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadBatch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read a bulk upload batch, its files and progress
 */

export function useGetUploadBatch<TData = Awaited<ReturnType<typeof getUploadBatch>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadBatch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUploadBatchQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRecordUploadBatchResultsUrl = (id: string,) => {




  return `/api/documents/batches/${id}/results`
}

/**
 * Records terminal outcomes for files in the batch and publishes
 * `document.uploaded` for each one that landed, so a bulk-uploaded
 * document follows the same event path as a single upload.
 *
 * Takes an array so a 500-file batch doesn't need 500 requests. Results
 * for files that already settled are ignored, making a retried report
 * safe.
 *
 * The batch closes itself once no file is still queued.
 *
 * Authorization: the caller's `X-Site-Claims` must include the batch's site.
 * @summary Report the outcome of one or more files in a batch
 */
export const recordUploadBatchResults = async (id: string,
    recordUploadBatchResultsRequest: RecordUploadBatchResultsRequest, options?: RequestInit): Promise<RecordUploadBatchResultsResponse> => {

  return customFetch<RecordUploadBatchResultsResponse>(getRecordUploadBatchResultsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recordUploadBatchResultsRequest)
  }
);}





export const getRecordUploadBatchResultsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordUploadBatchResults>>, TError,{id: string;data: RecordUploadBatchResultsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordUploadBatchResults>>, TError,{id: string;data: RecordUploadBatchResultsRequest}, TContext> => {

const mutationKey = ['recordUploadBatchResults'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordUploadBatchResults>>, {id: string;data: RecordUploadBatchResultsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  recordUploadBatchResults(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordUploadBatchResultsMutationResult = NonNullable<Awaited<ReturnType<typeof recordUploadBatchResults>>>
    export type RecordUploadBatchResultsMutationBody = RecordUploadBatchResultsRequest
    export type RecordUploadBatchResultsMutationError = ErrorResponse

    /**
 * @summary Report the outcome of one or more files in a batch
 */
export const useRecordUploadBatchResults = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordUploadBatchResults>>, TError,{id: string;data: RecordUploadBatchResultsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordUploadBatchResults>>,
        TError,
        {id: string;data: RecordUploadBatchResultsRequest},
        TContext
      > => {
      return useMutation(getRecordUploadBatchResultsMutationOptions(options), queryClient);
    }

export const getCancelUploadBatchUrl = (id: string,) => {




  return `/api/documents/batches/${id}/cancel`
}

/**
 * Marks the batch cancelled. Files already uploaded stay uploaded — the
 * bytes are in S3 either way, so removing them would be a surprise.
 * Cancelling an already-closed batch is a no-op.
 *
 * Authorization: the caller's `X-Site-Claims` must include the batch's site.
 * @summary Abandon whatever is still queued in a batch
 */
export const cancelUploadBatch = async (id: string, options?: RequestInit): Promise<UploadBatchDTO> => {

  return customFetch<UploadBatchDTO>(getCancelUploadBatchUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelUploadBatchMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelUploadBatch>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelUploadBatch>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelUploadBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelUploadBatch>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelUploadBatch(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelUploadBatchMutationResult = NonNullable<Awaited<ReturnType<typeof cancelUploadBatch>>>

    export type CancelUploadBatchMutationError = ErrorResponse

    /**
 * @summary Abandon whatever is still queued in a batch
 */
export const useCancelUploadBatch = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelUploadBatch>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelUploadBatch>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCancelUploadBatchMutationOptions(options), queryClient);
    }

export const getListDocumentLibraryUrl = (params: ListDocumentLibraryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/documents/library?${stringifiedParams}` : `/api/documents/library`
}

/**
 * A page of the site's typed documents, newest first, with how many pieces
 * of equipment each one covers.
 *
 * `group` and `type` both narrow, and `type` wins when both are given —
 * so the same endpoint serves the library's tabs (a group) and the
 * sidebar's nested entries (a single type) without the caller needing to
 * know which types belong to which group. An unrecognised value for either
 * is rejected rather than ignored: answering a request for "the drawings"
 * with the whole library reads as a broken filter.
 *
 * `search` matches the filename, case-insensitively. Narrow on purpose —
 * certificate numbers and tags aren't recorded against a document yet.
 *
 * Only documents that actually landed are listed, matching every other
 * count on the site.
 *
 * Authorization: the caller's `X-Site-Claims` must include `siteId`.
 * @summary The site's documents, filterable and searchable
 */
export const listDocumentLibrary = async (params: ListDocumentLibraryParams, options?: RequestInit): Promise<ListDocumentLibraryResponse> => {

  return customFetch<ListDocumentLibraryResponse>(getListDocumentLibraryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDocumentLibraryQueryKey = (params?: ListDocumentLibraryParams,) => {
    return [
    `/api/documents/library`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDocumentLibraryQueryOptions = <TData = Awaited<ReturnType<typeof listDocumentLibrary>>, TError = ErrorResponse>(params: ListDocumentLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentLibrary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentLibraryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocumentLibrary>>> = ({ signal }) => listDocumentLibrary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocumentLibrary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDocumentLibraryQueryResult = NonNullable<Awaited<ReturnType<typeof listDocumentLibrary>>>
export type ListDocumentLibraryQueryError = ErrorResponse


export function useListDocumentLibrary<TData = Awaited<ReturnType<typeof listDocumentLibrary>>, TError = ErrorResponse>(
 params: ListDocumentLibraryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentLibrary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentLibrary>>,
          TError,
          Awaited<ReturnType<typeof listDocumentLibrary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentLibrary<TData = Awaited<ReturnType<typeof listDocumentLibrary>>, TError = ErrorResponse>(
 params: ListDocumentLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentLibrary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentLibrary>>,
          TError,
          Awaited<ReturnType<typeof listDocumentLibrary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentLibrary<TData = Awaited<ReturnType<typeof listDocumentLibrary>>, TError = ErrorResponse>(
 params: ListDocumentLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentLibrary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The site's documents, filterable and searchable
 */

export function useListDocumentLibrary<TData = Awaited<ReturnType<typeof listDocumentLibrary>>, TError = ErrorResponse>(
 params: ListDocumentLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentLibrary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDocumentLibraryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListLinkReviewQueueUrl = (params: ListLinkReviewQueueParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/documents/link-queue?${stringifiedParams}` : `/api/documents/link-queue`
}

/**
 * The onboarding linking queue: typed site documents that landed, carry no
 * `equipment_document` link, and have not been put aside as not needed.
 *
 * Returned oldest-first and stable across calls, so paging through the
 * queue is coherent — position N means the same document each time.
 *
 * `counts` covers the whole site, not the page, and is what the screen's
 * header reads: `total` documents held, how many are already `linked`
 * (auto-matching does most of these at upload time), and how many were
 * `dismissed`. Whatever is left is the queue.
 *
 * Authorization: the caller's `X-Site-Claims` must include `siteId`.
 * @summary Site documents still waiting to be attached to equipment
 */
export const listLinkReviewQueue = async (params: ListLinkReviewQueueParams, options?: RequestInit): Promise<ListLinkReviewQueueResponse> => {

  return customFetch<ListLinkReviewQueueResponse>(getListLinkReviewQueueUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLinkReviewQueueQueryKey = (params?: ListLinkReviewQueueParams,) => {
    return [
    `/api/documents/link-queue`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLinkReviewQueueQueryOptions = <TData = Awaited<ReturnType<typeof listLinkReviewQueue>>, TError = ErrorResponse>(params: ListLinkReviewQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkReviewQueue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLinkReviewQueueQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLinkReviewQueue>>> = ({ signal }) => listLinkReviewQueue(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLinkReviewQueue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLinkReviewQueueQueryResult = NonNullable<Awaited<ReturnType<typeof listLinkReviewQueue>>>
export type ListLinkReviewQueueQueryError = ErrorResponse


export function useListLinkReviewQueue<TData = Awaited<ReturnType<typeof listLinkReviewQueue>>, TError = ErrorResponse>(
 params: ListLinkReviewQueueParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkReviewQueue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLinkReviewQueue>>,
          TError,
          Awaited<ReturnType<typeof listLinkReviewQueue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLinkReviewQueue<TData = Awaited<ReturnType<typeof listLinkReviewQueue>>, TError = ErrorResponse>(
 params: ListLinkReviewQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkReviewQueue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLinkReviewQueue>>,
          TError,
          Awaited<ReturnType<typeof listLinkReviewQueue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLinkReviewQueue<TData = Awaited<ReturnType<typeof listLinkReviewQueue>>, TError = ErrorResponse>(
 params: ListLinkReviewQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkReviewQueue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Site documents still waiting to be attached to equipment
 */

export function useListLinkReviewQueue<TData = Awaited<ReturnType<typeof listLinkReviewQueue>>, TError = ErrorResponse>(
 params: ListLinkReviewQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkReviewQueue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLinkReviewQueueQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLinkDocumentUrl = (id: string,) => {




  return `/api/documents/${id}/links`
}

/**
 * Creates a purpose-keyed link against an already-uploaded document, and
 * publishes `document.linked` per owner so the owning service can project
 * it.
 *
 * Several owners in one request is not batching for its own sake: a
 * certificate of conformity is issued against a design rather than a
 * serial number, so it legitimately covers every tag that shares it.
 * Linking those one request at a time would leave a partial set behind if
 * the caller stopped halfway.
 *
 * Idempotent per owner — re-linking an owner that is already linked
 * returns the existing link rather than failing. Each returned link says
 * in `created` which of the two happened.
 *
 * Authorization: the caller's `X-Site-Claims` must include the document's
 * site, and the caller must be at least an inspector.
 * @summary Attach a document to one or more owners
 */
export const linkDocument = async (id: string,
    linkDocumentRequest: LinkDocumentRequest, options?: RequestInit): Promise<LinkDocumentResponse> => {

  return customFetch<LinkDocumentResponse>(getLinkDocumentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkDocumentRequest)
  }
);}





export const getLinkDocumentMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkDocument>>, TError,{id: string;data: LinkDocumentRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof linkDocument>>, TError,{id: string;data: LinkDocumentRequest}, TContext> => {

const mutationKey = ['linkDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkDocument>>, {id: string;data: LinkDocumentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  linkDocument(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof linkDocument>>>
    export type LinkDocumentMutationBody = LinkDocumentRequest
    export type LinkDocumentMutationError = ErrorResponse

    /**
 * @summary Attach a document to one or more owners
 */
export const useLinkDocument = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkDocument>>, TError,{id: string;data: LinkDocumentRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkDocument>>,
        TError,
        {id: string;data: LinkDocumentRequest},
        TContext
      > => {
      return useMutation(getLinkDocumentMutationOptions(options), queryClient);
    }

export const getUnlinkDocumentUrl = (id: string,
    params: UnlinkDocumentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/documents/${id}/links?${stringifiedParams}` : `/api/documents/${id}/links`
}

/**
 * Removes one purpose-keyed link and publishes `document.unlinked`. The
 * document itself is untouched — it is still held against the site and may
 * be linked elsewhere. This is the way back from a mis-link; deleting the
 * document would take the bytes with it.
 *
 * Removing a link that is not there settles rather than failing, so an
 * undo that arrives twice is harmless.
 *
 * Authorization: the caller's `X-Site-Claims` must include the document's
 * site, and the caller must be at least an inspector.
 * @summary Detach a document from one owner
 */
export const unlinkDocument = async (id: string,
    params: UnlinkDocumentParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUnlinkDocumentUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnlinkDocumentMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkDocument>>, TError,{id: string;params: UnlinkDocumentParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlinkDocument>>, TError,{id: string;params: UnlinkDocumentParams}, TContext> => {

const mutationKey = ['unlinkDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkDocument>>, {id: string;params: UnlinkDocumentParams}> = (props) => {
          const {id,params} = props ?? {};

          return  unlinkDocument(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkDocument>>>

    export type UnlinkDocumentMutationError = ErrorResponse

    /**
 * @summary Detach a document from one owner
 */
export const useUnlinkDocument = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkDocument>>, TError,{id: string;params: UnlinkDocumentParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unlinkDocument>>,
        TError,
        {id: string;params: UnlinkDocumentParams},
        TContext
      > => {
      return useMutation(getUnlinkDocumentMutationOptions(options), queryClient);
    }

export const getSetDocumentLinkReviewUrl = (id: string,) => {




  return `/api/documents/${id}/link-review`
}

/**
 * Records that a document does not belong to any equipment, taking it out
 * of the linking queue — or clears that decision and returns it.
 *
 * Plenty of site documents legitimately belong to the site rather than to
 * a tag: a site layout drawing covering the whole plant. Without somewhere
 * to record that, they would sit in the queue permanently and the queue
 * would never reach zero.
 *
 * An audit report is not one of these. An audit is performed on a piece of
 * equipment, so its report belongs on the tag it audits and reaches the
 * queue like any other document.
 *
 * Authorization: the caller's `X-Site-Claims` must include the document's
 * site, and the caller must be at least an inspector.
 * @summary Put a document aside, or bring it back to the queue
 */
export const setDocumentLinkReview = async (id: string,
    setLinkReviewRequest: SetLinkReviewRequest, options?: RequestInit): Promise<LinkQueueDocumentDTO> => {

  return customFetch<LinkQueueDocumentDTO>(getSetDocumentLinkReviewUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setLinkReviewRequest)
  }
);}





export const getSetDocumentLinkReviewMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDocumentLinkReview>>, TError,{id: string;data: SetLinkReviewRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setDocumentLinkReview>>, TError,{id: string;data: SetLinkReviewRequest}, TContext> => {

const mutationKey = ['setDocumentLinkReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDocumentLinkReview>>, {id: string;data: SetLinkReviewRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  setDocumentLinkReview(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDocumentLinkReviewMutationResult = NonNullable<Awaited<ReturnType<typeof setDocumentLinkReview>>>
    export type SetDocumentLinkReviewMutationBody = SetLinkReviewRequest
    export type SetDocumentLinkReviewMutationError = ErrorResponse

    /**
 * @summary Put a document aside, or bring it back to the queue
 */
export const useSetDocumentLinkReview = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDocumentLinkReview>>, TError,{id: string;data: SetLinkReviewRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDocumentLinkReview>>,
        TError,
        {id: string;data: SetLinkReviewRequest},
        TContext
      > => {
      return useMutation(getSetDocumentLinkReviewMutationOptions(options), queryClient);
    }

